/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
const n="esri-compass",o={base:n,iconContainer:`${n}__icon-container`};export{o as css};
